"use client";

import React from "react";
import { Mail, Phone, MapPin, ArrowRight, Building2, Loader } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
export default function ConnectWithUs() {
  return;
}
function ConnectForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center text-center py-12 space-y-4 animate-in fade-in zoom-in duration-300">
        <div className="size-16 bg-green-50 text-green-600 flex items-center justify-center rounded-full mb-2">
          <Building2 className="size-8" />
        </div>
        <h3 className="text-xl font-bold text-primary">Inquiry Received</h3>
        <p className="text-muted-foreground max-w-xs mx-auto">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-6 rounded-none border-primary/20 hover:bg-primary/5">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <FormField control={control} name="full_name" rules={{
      required: "Full name is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary font-medium">Full Name <span className="text-destructive">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Nguyen Van A" {...field} className="rounded-none bg-background border-input focus-visible:ring-ring/30 h-11" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary font-medium">Email Address <span className="text-destructive">*</span></FormLabel>
              <FormControl>
                <Input type="email" placeholder="email@example.com" {...field} className="rounded-none bg-background border-input focus-visible:ring-ring/30 h-11" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary font-medium">Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+84 9xx xxx xxx" {...field} className="rounded-none bg-background border-input focus-visible:ring-ring/30 h-11" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="organization" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary font-medium">Organization / Company</FormLabel>
            <FormControl>
              <Input placeholder="Company XYZ" {...field} className="rounded-none bg-background border-input focus-visible:ring-ring/30 h-11" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Please enter your message"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary font-medium">Message <span className="text-destructive">*</span></FormLabel>
            <FormControl>
              <Textarea placeholder="Tell us about your project or partnership proposal..." {...field} className="rounded-none bg-background border-input focus-visible:ring-ring/30 min-h-[120px] resize-y" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/5 border border-destructive/20 text-destructive text-sm">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full rounded-none h-12 text-base font-semibold bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/10">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Sending Inquiry...
          </> : <>
            Send Message <ArrowRight className="ml-2 size-4" />
          </>}
      </Button>
    </Form>;
}